export enum GlobalMessages {
  activeText = "global.activeText",
  inactiveText = "global.inactiveText",
  yesText = "global.yesText",
  noText = "global.noText",
  filtersText = "global.filtersText",
  underConstructionText = "global.underConstructionText",
  columnActions = "global.columns.columnActions",
  buttonAdd = "global.buttons.buttonAdd",
  buttonEdit = "global.buttons.buttonEdit",
  buttonDelete = "global.buttons.buttonDelete",
  buttonRefresh = "global.buttons.buttonRefresh",
  buttonClose = "global.buttons.buttonClose",
  buttonPrint = "global.buttons.buttonPrint",
  buttonExport = "global.buttons.buttonExport",
  buttonCancel = "global.buttons.cancel",
  buttonAccept = "global.buttons.accept",
  buttonReject = "global.buttons.reject",
  buttonSaveChanges = "global.buttons.saveChanges",
  buttonView = "global.buttons.view",
  buttonHelp = "global.buttons.help",
  tooltipFixed = "global.tooltip.fixed",
  noItemsText = "global.noItemsText",
  clientSelectInstruction = "global.clientSelectInstruction",
  entityClassificationSupplyType = "global.entities.entityClassificationSupplyType",
  entityConcreteBatchingPlant = "global.entities.entityConcreteBatchingPlant",
  entityMeasureUnitType = "global.entities.entityMeasureUnitType",
  entitySupplier = "global.entities.entitySupplier",
  entityConcreteCharacteristicsType = "global.entities.entityConcreteCharacteristicsType",
  entityGravel = "global.entities.entityGravel",
  entitySlump = "global.entities.entitySlump",
  entityConcreteRecipeFamilyApplicationType = "global.entities.entityConcreteRecipeFamilyApplicationType",
  invalidFormInputs = "global.validations.invalidFormInputs",
  invalidMinEffectiveDate = "global.validations.invalidMinEffectiveDate",
  measureUnitCharacteristicMPa = "global.measureUnitCharacteristic.MPa",
  emptySelectField = "global.fields.emptySelectField",
  selectClient = "global.fields.selectClient",
  dayDeliveryText = "global.dayDeliveryText",
  lastConcretingRequestsText = "global.lastConcretingRequestsText",
  lastContractsText = "global.lastContractsText",
  searchText = "global.searchText",
  showMore = "global.showMore",
  reversibleAction = "global.reversibleAction",
  successText = "global.successText",
  warningText = "global.warningText",
  errorText = "global.errorText",
  lgpdTitle = "global.lgpdTitle"
}

export interface TranslationGlobalMessages {
  [GlobalMessages.activeText]: string;
  [GlobalMessages.inactiveText]: string;
  [GlobalMessages.yesText]: string;
  [GlobalMessages.noText]: string;
  [GlobalMessages.filtersText]: string;
  [GlobalMessages.underConstructionText]: string;
  [GlobalMessages.columnActions]: string;
  [GlobalMessages.buttonAdd]: string;
  [GlobalMessages.buttonEdit]: string;
  [GlobalMessages.buttonDelete]: string;
  [GlobalMessages.buttonRefresh]: string;
  [GlobalMessages.buttonClose]: string;
  [GlobalMessages.buttonPrint]: string;
  [GlobalMessages.buttonExport]: string;
  [GlobalMessages.buttonCancel]: string;
  [GlobalMessages.buttonAccept]: string;
  [GlobalMessages.buttonReject]: string;
  [GlobalMessages.buttonSaveChanges]: string;
  [GlobalMessages.buttonView]: string;
  [GlobalMessages.buttonHelp]: string;
  [GlobalMessages.tooltipFixed]: string;
  [GlobalMessages.noItemsText]: string;
  [GlobalMessages.clientSelectInstruction]: string;
  [GlobalMessages.entityClassificationSupplyType]: string;
  [GlobalMessages.entityConcreteBatchingPlant]: string;
  [GlobalMessages.entityMeasureUnitType]: string;
  [GlobalMessages.entitySupplier]: string;
  [GlobalMessages.entityConcreteCharacteristicsType]: string;
  [GlobalMessages.entityGravel]: string;
  [GlobalMessages.entitySlump]: string;
  [GlobalMessages.entityConcreteRecipeFamilyApplicationType]: string;
  [GlobalMessages.invalidFormInputs]: string;
  [GlobalMessages.invalidMinEffectiveDate]: string;
  [GlobalMessages.measureUnitCharacteristicMPa]: string;
  [GlobalMessages.emptySelectField]: string;
  [GlobalMessages.selectClient]: string;
  [GlobalMessages.dayDeliveryText]: string;
  [GlobalMessages.lastConcretingRequestsText]: string;
  [GlobalMessages.lastContractsText]: string;
  [GlobalMessages.searchText]: string;
  [GlobalMessages.showMore]: string;
  [GlobalMessages.reversibleAction]: string;
  [GlobalMessages.successText]: string;
  [GlobalMessages.warningText]: string;
  [GlobalMessages.errorText]: string;
  [GlobalMessages.lgpdTitle]: string;
}
